import React from 'react'
import { Link } from 'react-router-dom'
import { Link as MuiLink } from '@ally/metronome-ui'
import { setLinkTarget } from '../../utils'
import { isExternalLink } from './utils'

interface MboxTargetLinkProps {
  id?: string
  ctaNewTab?: boolean
  to: string
  text: string
  ariaText?: string
  className?: string // Required to apply styles from consuming component
  variant?:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'disabled'
    | 'login'
    | 'destructive'
    | 'icon'
}

export const MboxTargetLink: React.FC<MboxTargetLinkProps> = ({
  id,
  ctaNewTab,
  to,
  text,
  variant,
  ariaText,
  className,
}) => {
  const isExternal = isExternalLink(to)
  const target = setLinkTarget(!!ctaNewTab)
  return (
    <>
      {isExternal ? (
        <MuiLink
          id={id}
          text={text}
          href={to}
          target={target}
          variant={variant}
          aria-label={ariaText}
          className={className}
        />
      ) : (
        <MuiLink text={text} variant={variant} className={className}>
          <Link id={id} to={to} target={target} aria-label={ariaText} />
        </MuiLink>
      )}
    </>
  )
}
